// Written in this round about way for babel-transform-imports
import StaticRouter from "react-router/es/StaticRouter";

export default StaticRouter;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_react-router-dom@4.3.1@react-router-dom/es/StaticRouter.js
// module id = 1174
// module chunks = 0